import React, {useCallback, useMemo, useState} from "react";
import {array, bool, func, object, oneOfType, string} from "prop-types";
import {withTranslation} from "react-i18next";
import "./index.scss";
import {Icon} from "features/components/icon";
import {get, xor} from "lodash";
import {useOnClickOutside} from "services/utils/utils";

export const Select = (props) => {
    const {value = "", values, onChange, t, backgroundWhite, className, placeholder, disabled, multiple, noSelectionString} = props;

    const isMultiple = multiple || false;

    const [open, setOpen] = useState(false);

    const toggleOpen = useCallback(() => {
        setOpen(!open);
    }, [open]);

    const setValue = useCallback((val) => {
        if(!isMultiple) {
            onChange(val);
            setOpen(false);
        } else {
            onChange(xor(value, [val]));
        }
    }, [onChange, setOpen, isMultiple, value]);

    const hasBackgroundWhite = backgroundWhite || false;
    const isDisabled = disabled || false;

    const valueToShow = useMemo(() => {
        if(!value || value.length === 0) {
            return noSelectionString ? noSelectionString : t("common.select");
        }
        if (!isMultiple) {
            return t(get(values.find(i => i.key === value), 'value', value));
        } else {
            return value.map(val => {
                return t(get(values.find(i => i.key === val), 'value', val))
            }).join(", ");
        }
    }, [value, isMultiple, noSelectionString, t, values])

    const isSelected = useCallback((val) => {
        if(!isMultiple) {
            return val === value;
        } else {
            return value.includes(val);
        }
    }, [value, isMultiple]);

    const selectRef = React.useRef(null);

    /* istanbul ignore next */
    useOnClickOutside(selectRef, () => {
        setOpen(false);
    })
    return <div ref={selectRef} className={`select ${hasBackgroundWhite ? "background-white" : ""} ${className || ""} ${isDisabled ? "disabled" : ""}`}>
        <div className={"field"} onClick={toggleOpen}>
            <span className={"placeholder"}>{placeholder}</span>
            <span className={"indicator"}><Icon>{open ? "arrow-dropdown-up" : "arrow-dropdown-down"}</Icon></span>
            <span className={"value"}>{valueToShow}</span>
        </div>
        { open && <div className="dropdown">
            {values.map(i => <div
                key={i.key}
                onClick={() => setValue(i.key)}
            >
                <span>{t(i.value)}</span>
                {isSelected(i.key) && <Icon>check</Icon>}
            </div>)}
        </div> }
    </div>
};

Select.propTypes = {
    value: oneOfType([string, array]).isRequired,
    values: array.isRequired,
    onChange: func.isRequired,
    placeholder: oneOfType([string, object]),
    backgroundWhite: bool,
    className: string,
    disabled: bool,
    multiple: bool,
    noSelectionString: oneOfType([string, object])
};

export default withTranslation()(Select);